import * as apiProfileActions from 'services/api-profile-actions';
import { UpdatePasswordRequest, UpdatePasswordResponse } from 'types/profile';
import { AppThunk } from '..';
import {
  setUpdatePasswordResponse,
  updatePasswordEnd,
  updatePasswordError,
  updatePasswordStart,
} from './profile-slice';

export const updatePasswordAction =
  (request: UpdatePasswordRequest): AppThunk =>
  async dispatch => {
    try {
      dispatch(updatePasswordStart());

      const data: UpdatePasswordResponse | null =
        await apiProfileActions.updatePassword(request);

      if (!data) {
        dispatch(updatePasswordEnd());
        return;
      }

      dispatch(setUpdatePasswordResponse(data));

      if (request.callback) request.callback(data);
    } catch (Exception: any) {
      console.error(Exception);
      dispatch(updatePasswordError(Exception));
    }
  };
